$(document).ready(function() {

  jQuery(window).click(function(e) {
    let windowWidth = $(window).width();
    let elClass = jQuery(e.target).attr("class");
    let searchInput = jQuery('.header-desk-search .search__input.field__input');
    let mobileSearchInput = jQuery('.empty-search-container .boost-sd__search-bar-input');
    jQuery('#bc-instant-search').css('opacity','0');
    jQuery('#bc-instant-search').removeClass('active');
    
    //console.log(elClass);
    if( jQuery(e.target).hasClass('boost-sd__button-text-x--close') || jQuery(e.target).parents().hasClass("boost-sd__button-text-x--close") ) {
      //console.log('boost-sd__button-text-x--close');
      jQuery('body').removeClass('search-active');
      jQuery('#empty-search-container').addClass('hidden');
      jQuery('#empty-search-bg').removeClass('active');
      jQuery('#bc-instant-search').removeClass('active');
    } else {    
      if (jQuery(e.target).hasClass('search__input')) {
        //console.log(elClass);
        if( searchInput.val() == "") { 
          //console.log('empty input');
          jQuery('#empty-search-container').removeClass('hidden');
          jQuery('#empty-search-bg').addClass('active');
          jQuery('#bc-instant-search').removeClass('active');
          jQuery('#bc-instant-search').css('opacity','0');
          setTimeout(() => {
            setSearchWidth();
          }, 50);
        } else {
          //console.log('input = ' + searchInput.val());
          jQuery('#empty-search-container').addClass('hidden');
          jQuery('#empty-search-bg').removeClass('active');
          jQuery('#bc-instant-search').addClass('active');
          jQuery('#bc-instant-search').css('opacity','1');
        }
      } else if (jQuery(e.target).hasClass('boost-sd__search-bar-input') ) {
        //console.log(elClass);
        if( mobileSearchInput.val() == "" ) { 
          //console.log('empty input');
          jQuery('#empty-search-container').removeClass('hidden');
          jQuery('#empty-search-bg').addClass('active');
          jQuery('#bc-instant-search').removeClass('active');
          jQuery('#bc-instant-search').css('opacity','0');
          setTimeout(() => {
            setSearchWidth();
          }, 50);
        } else {
          //console.log('input = ' + searchInput.val());
          jQuery('#empty-search-container').addClass('hidden');
          jQuery('#empty-search-bg').removeClass('active');
          jQuery('#bc-instant-search').addClass('active');
          jQuery('#bc-instant-search').css('opacity','1');
        }
      } else if (jQuery(e.target).hasClass('boost-sd__button-text-x--clear') || jQuery(e.target).hasClass('modal__toggle-open') || jQuery(e.target).parents().hasClass("boost-sd__button-text-x--clear") || jQuery(e.target).parents().hasClass("mobile_search") ) {     
        //console.log('boost-sd__button-text-x--clear');
        searchInput.val('');
        mobileSearchInput.val('');
        setTimeout(() => {
          jQuery('body').addClass('search-active');
          jQuery('#empty-search-container').removeClass('hidden');
          jQuery('#empty-search-bg').addClass('active');
          jQuery('#bc-instant-search').removeClass('active');
          jQuery('#bc-instant-search').css('opacity','0');
        }, 50);
      } else {  
        //console.log('else');
        jQuery('body').removeClass('search-active');
        jQuery('#empty-search-container').addClass('hidden');
        jQuery('#empty-search-bg').removeClass('active');
        jQuery('#bc-instant-search').removeClass('active');
        jQuery('#bc-instant-search').css('opacity','0');
        //if( windowWidth < 991) {
        setTimeout(() => {
          jQuery('body').removeClass('boost-sd__search-opening');
          jQuery('.template-search__search .reset__button').addClass('boost-sd__g-hide');
          searchInput.val('');
          mobileSearchInput.val('');
        }, 100);
        //} 
      }
    }
  });

  jQuery(window).on('change input', function(e) {
    let elClass = jQuery(e.target).attr("class");    
      //console.log(elClass);
    if( jQuery(e.target).hasClass('search__input field__input') || jQuery(e.target).hasClass('boost-sd__search-bar-input') ) {    
      //console.log(elClass);
      var searchInput = jQuery(e.target).val();
      //console.log(searchInput);
      if( searchInput == "" ) { 
          jQuery('#empty-search-container').removeClass('hidden');
          jQuery('#empty-search-bg').addClass('active');
          jQuery('#bc-instant-search').removeClass('active');
          jQuery('#bc-instant-search').css('opacity','0');
          setTimeout(() => {
            setSearchWidth();
          }, 50);
      } else {      
        jQuery('#bc-instant-search').addClass('active');
        jQuery('#bc-instant-search').css('opacity','1');
        setTimeout(() => {
          jQuery('#empty-search-bg').removeClass('active');
          jQuery('#empty-search-container').addClass('hidden');
        }, 50);
      }
    }
  });

  function setSearchWidth() {
    
    const searchInput = document.querySelector('.header-desk-search .search__input.field__input').getBoundingClientRect();
    const position = 'absolute';

    // + 2 px => border of input
    // + 4 px: distance from input from input autocomplete to this input
    // window.scrollY: if window has scroll Y
    const searchScroll = window.scrollY;
    let searchTop = searchInput.height + searchInput.top + 8;
    // - 20: distance from suggestion to bottom of window
    const _maxHeight = window.innerHeight - searchTop - 20;

    let _positionLeftOrRight = `left: ${searchInput.left}px`;

    // auto detect suggestion position
    if (window.innerWidth / 2 < searchInput.left) {
      _positionLeftOrRight = `right: ${window.innerWidth - searchInput.right}px`;
    }

    searchTop = searchTop + searchScroll;

    document.querySelector('#empty-search-container').setAttribute(
      'style',
      `position: ${position}; top: ${searchTop}px; ${_positionLeftOrRight}; z-index: 999999998;`
    );  
  }
});